// extracted by mini-css-extract-plugin
module.exports = {"banner":"market-banner_banner__Cy_Nx","banner-gradient":"market-banner_banner-gradient__dmVW_"};